import React, { ReactElement } from 'react';
import { Icon, Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';

type Props = { children?: ReactElement } & SpinProps;

export default (props: Props) => {
  const { children, ...p } = props;
  return (
    <Spin {...p} indicator={<Icon type="loading" />}>
      {children}
    </Spin>
  );
};
